import * as React from "react"
import type { SVGProps } from "react"
const SvgCart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7 22.43q-.82 0-1.41-.59A2 2 0 0 1 5 20.43q0-.82.59-1.41a2 2 0 0 1 1.41-.6q.82 0 1.41.6.6.59.59 1.4c-.01.82-.2 1.03-.59 1.42a2 2 0 0 1-1.41.59m10 0q-.83 0-1.41-.59a2 2 0 0 1-.59-1.41q0-.82.59-1.41a2 2 0 0 1 1.41-.6q.83 0 1.41.6.6.59.59 1.4c-.01.82-.2 1.03-.59 1.42a2 2 0 0 1-1.41.59m-10.85-16 2.4 5h7l2.75-5zm-.95-2h14.75q.57 0 .88.51.3.51.02 1.04l-3.55 6.4a2 2 0 0 1-.74.77 2 2 0 0 1-1.01.28H8.1l-1.1 2h11q.42 0 .71.29.3.29.29.7c-.01.42-.1.53-.29.72a1 1 0 0 1-.71.29H7q-1.13 0-1.7-.99a1.9 1.9 0 0 1-.05-1.96l1.35-2.45L3 4.43H2a1 1 0 0 1-.71-.29A1 1 0 0 1 1 3.43q0-.43.29-.71a1 1 0 0 1 .71-.3h1.63a1 1 0 0 1 .52.16q.26.15.38.42z" />
  </svg>
)
export default SvgCart
